import React, { useCallback, useState } from "react";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import Modal from "react-bootstrap/Modal";

export const SearchBarDesktop = ({ dataSearch, setDataSearch, onSearch }) => {
    const [showModal, setShowModal] = useState(false);
    const toggleModal = () => setShowModal(!showModal);

    const handleSearch = useCallback((e) => {
        if (e) e.preventDefault();
        const newSearchData = { ...dataSearch, iPageIndex: 1 };
        setDataSearch(newSearchData);
        onSearch(newSearchData);
        if (showModal) setShowModal(false);
    }, [setDataSearch, onSearch, dataSearch, showModal]);

    const handleDateChange = (field) => (date) => {
        setDataSearch(prev => ({ ...prev, [field]: date }));
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleSearch(event);
        }
    };

    const renderFormFields = () => (
        <>
            <div className="input-sm-new input-new-18" style={{ flex: 1, minWidth: '180px' }}>
                <label className="font-color-default font-bold">Từ ngày</label>
                <DateTimePicker
                    value={dataSearch.dtFromTime}
                    onChange={handleDateChange("dtFromTime")}
                    placeholder="Chọn ngày bắt đầu"
                    maxDate={dataSearch.dtToTime}
                />
            </div>
            <div className="input-sm-new input-new-18" style={{ flex: 1, minWidth: '180px' }}>
                <label className="font-color-default font-bold">Đến ngày</label>
                <DateTimePicker
                    value={dataSearch.dtToTime}
                    onChange={handleDateChange("dtToTime")}
                    placeholder="Chọn ngày kết thúc"
                    minDate={dataSearch.dtFromTime}
                />
            </div>
        </>
    );

    return (
        <>
            <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2" style={{ marginBottom: 16 }} onKeyDown={handleKeyDown}>
                <div className="card-body card-body-v2" style={{ padding: '12px 16px 8px 16px' }}>
                    <div className="search-new d-flex flex-row align-items-end justify-content-start gap-3 flex-wrap">

                        {renderFormFields()}

                        <div className="input-sm-new input-new-18 search-main-new">
                            <button
                                type="button"
                                className="btn btn-info-new"
                                style={{ paddingTop: "7px" }}
                                onClick={handleSearch}
                            >
                                <i className="la la-search"></i>
                                <span> &nbsp; Tìm kiếm</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
                <div className="col-sm-12">
                    <div className="form row">
                        <div className="col-12">
                            <button
                                type="button"
                                className="btn btn-info-new"
                                onClick={toggleModal}
                            >
                                Tìm kiếm <i className="la la-search"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={showModal}
                onHide={toggleModal}
                dialogClassName="modal-lg"
                className="modal-new modal fade text-left"
                backdrop="static"
            >
                <Modal.Header>
                    <h2 className="modal-title p-1">
                        Tìm kiếm
                    </h2>
                    <button type="button" className="close-popup-new" onClick={toggleModal}>
                        <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        {renderFormFields()}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-info"
                        onClick={handleSearch}
                    >
                        <i className="fas fa-search"></i> Tìm kiếm
                    </button>
                    <button type="button" className="btn btn-info" onClick={toggleModal}>
                        <i className="fas fa-times"></i> Đóng
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};